// Constants
import * as Constants from "../../constants";

// Helpers
import DB from "../../helpers/db";

import { LOOKUP } from "../definitions";
// import { getToken } from "../../helpers/utils";

export const fetchLookup = () => async (dispatch) => {
  try {
    dispatch({
      type: LOOKUP.START_FETCH,
    });
    await DB({
      isPublic: true,
      method: Constants.EMPTY,
      url: "/config",
    }).then((response) => {
      dispatch({
        type: LOOKUP.FINISH_FETCH,
        payload: response.data.data,
      });
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: LOOKUP.FAIL_FETCH,
      payload: error,
    });
  }
};
